import { useEffect, useState } from "react";
import config from "../../config/config";
import TokenError from "../tokenError";
import { Typography, Grid2, Select, MenuItem, Button, Switch, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Snackbar, TableSortLabel, Dialog, DialogTitle, DialogContent, FormControlLabel, DialogActions, TextField } from "@mui/material";
import { makeGetRequestToUrl, makePostRequestToUrl } from "../commonFunc";
import { useNavigate } from "react-router-dom";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';

const Partners = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);

    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [open, setOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [rows, setRows] = useState([]);
    const [partnerId, setPartnerId] = useState('');
    const [partnerName, setPartnerName] = useState('');
    const [isActive, setIsActive] = useState(false);

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('partner_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [saving, setSaving] = useState(false);

    const rowArray = Array.isArray(rows) ? rows : [];
    const totalEntries = rowArray.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    //sorting
    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const fetchPromoData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/panel/fetch_partners_promotions';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        fetchPromoData();
    }, [])

    const handleOpenAddModal = () => {
        setOpen(true);
        setEditMode(false);
        setPartnerId('');
        setPartnerName('');
        setIsActive(true);
    };

    const handleOpenEditModal = (row) => {
        setOpen(true);
        setEditMode(true);
        setPartnerId(row.partner_id);
        setPartnerName(row.name);
        setIsActive(row.is_active);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const handleCloseModal = () => {
        setOpen(false);
    };

    const handleSavePartner = async() => {
        if (saving) return; 
        setSaving(true);
        const token = localStorage.getItem('token');
        const payload = {
            token,
            name: partnerName,
            is_active: isActive ? 1 : 0
        };
        if(partnerId!=''){
            payload.partner_id = partnerId;
        }
        try {
            const url = operationsUrl + '/panel/add_update_promo_partners';
            const response = await makePostRequestToUrl(url,payload, token);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchPromoData();
                setOpen(false);
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            setMessage(error);
        }
        finally{
            setSaving(false);
        }
    }

    const handleStatusChange = async(row, status) => {
        const token = localStorage.getItem('token');
        const payload = {
            token,
            partner_id: row.partner_id,
            is_active: status ? 1 :0
        };
        try {
            const url = operationsUrl + '/panel/add_update_promo_partners';
            const response = await makePostRequestToUrl(url,payload, token);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchPromoData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            setMessage(error);
        }
    }

    return (
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Partners
            </Typography>

            {/* <Grid2 item container spacing={2} alignItems="center" sx={{ marginTop: '2%', marginBottom: '2%' }}> */}
                <Grid2 item sx={{mt:2}}>
                    <Button
                        variant="contained" onClick={handleOpenAddModal}
                        style={{width:'185px',height: '50px',backgroundColor:'#000000',textTransform:'none',borderRadius:'8px'}}>
                        + Add Partner
                    </Button>
                </Grid2>
            {/* </Grid2> */}

            <TableContainer className="table-container" sx={{ maxHeight:'70vh' }}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'partner_id'} direction={orderBy === 'partner_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('partner_id')}>
                                ID
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'name'} direction={orderBy === 'name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('name')}>
                                Name
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'is_active'} direction={orderBy === 'is_active' ? order : 'asc'}
                                    onClick={() => handleRequestSort('is_active')}>
                                        Status
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {rows.filter((row) => rows)
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => {

                            return(
                                <TableRow key={row.id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.partner_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '120px' }}>{row.name}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Button
                                            variant="contained" value={row.is_active} onClick={() => handleStatusChange(row,true)} 
                                            style={{ backgroundColor: row.is_active ? '#0DBA78' : '#F4F4F4', color: row.is_active ? '#FFFFFF' : '#9E9E9E',textTransform: 'none',
                                                borderRadius: '8px 0 0 8px',boxShadow: 'none',padding: '6px 16px',minWidth: '80px'}}>
                                            Enable
                                        </Button>
                                        <Button
                                            variant="contained" value={row.is_active} onClick={() => handleStatusChange(row,false)} 
                                            style={{backgroundColor: !row.is_active ? '#D14545' : '#F4F4F4',color: !row.is_active ? '#FFFFFF' : '#9E9E9E',
                                                textTransform: 'none',borderRadius: '0 8px 8px 0',boxShadow: 'none',padding: '6px 16px', minWidth: '80px',
                                            }}>
                                            Disable
                                        </Button>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEditModal(row)}
                                            sx={{
                                                backgroundColor: '#EFFBF7', color: '#0DBA78', border: '1px solid #0DBA78', textTransform: 'none',
                                                borderRadius: '8px', minWidth:'40px', boxShadow:'none', width:"90px",
                                                '&:hover': {backgroundColor: '#0DBA78', color: 'white'},
                                                '&:active': { backgroundColor: '#0DBA78', color: 'white'}
                                            }}>
                                            
                                            <Typography sx={{marginRight:'6%'}}>Edit</Typography>
                                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.84304 9.45074L5.39054 6.89324C5.47025 6.53784 5.64979 6.21258 5.90804 5.95574L10.9105 0.998238C11.4178 0.481469 12.1066 0.182825 12.8305 0.165738C13.3765 0.157914 13.9031 0.368518 14.293 0.750738C15.1452 1.75759 15.0352 3.26115 14.0455 4.13324L9.04304 9.13574C8.7862 9.39399 8.46095 9.57353 8.10554 9.65324L5.54804 10.2007H5.40554C5.21858 10.2079 5.04 10.1228 4.92774 9.97316C4.81547 9.82347 4.78382 9.62822 4.84304 9.45074ZM6.70304 6.75824C6.59796 6.86007 6.52496 6.99043 6.49304 7.13324L6.12554 8.88074L7.87304 8.50574C8.01585 8.47382 8.14621 8.40082 8.24804 8.29574L13.2505 3.29324C13.7986 2.85451 13.9073 2.0636 13.498 1.49324C13.3188 1.32202 13.0783 1.23012 12.8305 1.23824C12.4035 1.25539 11.9999 1.43834 11.7055 1.74824L6.70304 6.75824Z" fill="currentColor"/>
                                                <path d="M13.933 6.19574C13.6241 6.19978 13.3746 6.44927 13.3705 6.75824V11.0257C13.3806 11.6289 13.148 12.2109 12.7249 12.641C12.3019 13.0711 11.7238 13.3133 11.1205 13.3132H3.97305C2.72607 13.2888 1.72688 12.2729 1.72305 11.0257V3.90824C1.74352 2.65955 2.7617 1.65807 4.01055 1.65824H8.27805C8.58871 1.65824 8.84055 1.4064 8.84055 1.09574C8.84055 0.785078 8.58871 0.533238 8.27805 0.533238H3.97305C2.10292 0.533125 0.581098 2.03823 0.560547 3.90824V11.0257C0.560547 12.9104 2.08838 14.4382 3.97305 14.4382H11.0905C12.9723 14.4341 14.4956 12.9075 14.4955 11.0257V6.75824C14.4915 6.44927 14.242 6.19978 13.933 6.19574Z" fill="currentColor"/>
                                            </svg>
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>

                {/* pagination */}
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                    <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Dialog open={open} onClose={handleCloseModal} fullWidth maxWidth="xs"
                PaperProps={{ sx: { borderRadius: '12px', padding: '8px' } }}>
                <DialogTitle sx={{ fontSize: '22px', fontWeight: 500 }}>
                    {editMode ? 'Edit Partner' : 'Add Partner'}
                    <hr/>
                </DialogTitle>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: '8px !important' }}>
                    <TextField
                        label="Partner Name"
                        value={partnerName}
                        onChange={(e) => setPartnerName(e.target.value)}
                        fullWidth
                        variant="outlined"
                        sx={{ mt: 1 }}
                    />
                </DialogContent>
                <DialogActions sx={{ p: 2, mt: 1 }}>
                    <Button
                        onClick={handleCloseModal}
                        sx={{ textTransform: 'none', color: '#000000', borderRadius: '8px', border: '1px solid #cccccc' }}>
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSavePartner}
                        disabled={saving}
                        sx={{ backgroundColor: '#000000', textTransform: 'none', borderRadius: '8px' }}>
                        {editMode ? 'Update' : 'Add'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
            
        </div>
    );
};

export default Partners;